import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import Transition from '../../../../components/dialogs/Transition';
import FormComponent from '../../../../components/FormComponent';
import { dialogStyles } from './dialogStyles';

const styles = () => {
	return {
		...dialogStyles,
	};
};

class MobileDeliveryErrorDialog extends FormComponent {
	componentDidMount() {}

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { open, classes, errorMessages } = this.props;
		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<DialogContent dividers={true} style={{ position: 'relative' }}>
					<div className={classes.dialogTitle}>
						<div>Error Encountered</div>
					</div>
					<div fontSize="120%" style={{ padding: '1vw' }}>
						{errorMessages.map((errorMessage) => {
							return <div key={errorMessage}>{errorMessage}</div>;
						})}
					</div>
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<div style={{ display: 'flex', width: '100%', padding: '0px 2vw' }}>
						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileDeliveryErrorDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object,
	errorMessage: PropTypes.array,
};

export default _.flow([withStyles(styles)])(MobileDeliveryErrorDialog);
